import _ from 'lodash';
import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const FETCH_FAQS = 'FETCH_FAQS';
export const SELECTED_FAQ = 'SELECTED_FAQ';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';

export const fetchFAQs = (session, callback) => {
  // let filter = encodeURI(`(eventid=${session.eventid})`);
  // let url = `${INSTANCE_URL}/api/v2/eventify/_table/doc_faqs?include_count=true&filter=(${filter})`;

  let fetchUrl = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;
  let categoryBodyObj = {
      requesttype: 'fetchCategoryList',
      eventid: session.eventid
    },
    listBodyObj = {
      requesttype: 'fetcheventguidelist',
      eventid: session.eventid
    };

  return dispatch => {
    postRequest(
      fetchUrl,
      categoryBodyObj,
      session,
      dispatch,
      categoryRes => {
        let categoryDataArr = categoryRes.resource.data,
          categoryCount = categoryRes.resource.data.length;

        postRequest(
          fetchUrl,
          listBodyObj,
          session,
          dispatch,
          listRes => {
            let listDataArr = listRes.resource.data,
              listCount = listRes.resource.data.length;

            let workingArr = categoryDataArr;
            _.map(workingArr, cate => {
              cate.data = _.filter(
                listDataArr,
                item => item.category == cate.category
              );

              cate.data = _.orderBy(cate.data, 'displayorder', 'asc');
            });
            workingArr = _.orderBy(workingArr, 'displaycategoryorder', 'asc');

            dispatch({
              type: FETCH_FAQS,
              payload: {
                count: listCount,
                category: { data: categoryDataArr, count: categoryCount },
                list: { data: listDataArr, count: listCount },
                data: workingArr
              }
            });
            callback({
              success: 2,
              count: listCount,
              category: { data: categoryDataArr, count: categoryCount },
              list: { data: listDataArr, count: listCount },
              data: workingArr
            });
          },
          listError => {
            callback({
              success: 1,
              message: listError,
              type: 'list',
              cateData: { data: categoryDataArr, count: categoryCount }
            });
          }
        );
      },
      categoryError => {
        callback({ success: 0, message: categoryError, type: 'category' });
      }
    );
  };

  // return dispatch => {
  //   getRequest(
  //     url,
  //     session,
  //     dispatch,
  //     response => {
  //       let faqArr = _.orderBy(response.resource, 'displayorder', 'asc');

  //       dispatch({
  //         type: FETCH_FAQS,
  //         payload: { count: response.meta.count, data: faqArr }
  //       });
  //       callback({
  //         success: true,
  //         count: response.meta.count,
  //         data: faqArr
  //       });
  //     },
  //     error => {
  //       callback({ success: false, message: error });
  //     }
  //   );
  // };
};

export const clearFAQList = () => {
  return dispatch => {
    dispatch({ type: FETCH_FAQS, payload: {} });
  };
};

export const selectFAQ = value => {
  return dispatch => {
    dispatch({ type: SELECTED_FAQ, payload: {} });
    dispatch({ type: SELECTED_FAQ, payload: value });
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};
